<template>
    <div
        :id="id"
        class="container-block"
        :data-direction="direction"
        :data-index-path="indexPath"
        :style="containerStyle"
        :class="containerClass"
    >
        <template
            v-for="(child) in children"
            :key="child.id"
        >
            <CustomPageBlock
                :block="child"
                :model-value="child.currentValue"
                :data-testid="`custom-page-block-${kebabCase((child as ExtendedBlock<CPInputConfiguration>).fieldName || child.type)}`"
            />
        </template>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { kebabCase } from 'change-case'
import type { CPInputConfiguration, ExtendedBlock } from 'widget-components/integrations/CustomPage/types'
import type { StickyPosition } from 'widget-components/components/Container/container-sticky-position'
import { CustomPageBlock } from 'widget-components/integrations/CustomPage'
import type { Breakpoint } from 'widget-components/composables/breakpoints'

defineOptions({ inheritAttrs: false })

const props = withDefaults(defineProps<{
    id?: string
    children: ExtendedBlock[]
    direction?: 'row' | 'column' | 'responsive' | 'inline-text'
    gap?: string
    alignItems?: string
    justifyContent?: string
    flexMultiplier?: number
    stickyPosition?: StickyPosition
    responsiveVisibility?: 'always' | Breakpoint
    indexPath?: number[]
}>(), {
    direction: 'row',
    gap: '10px',
    alignItems: 'start',
    justifyContent: 'start',
    flexMultiplier: 1,
    responsiveVisibility: 'always',
})

const containerStyle = computed(() => ({
    '--direction': props.direction !== 'responsive' ? props.direction : undefined,
    '--gap': props.gap,
    '--align-items': props.alignItems,
    '--justify-content': props.justifyContent,
}))

const containerClass = computed(() => ({
    [`${props.responsiveVisibility}-visible`]: props.responsiveVisibility !== 'always',
    'direction-responsive': props.direction === 'responsive',
    'direction-inline-text': props.direction === 'inline-text',
}))

</script>

<style lang="sass" scoped>
@import "./Container.sass"
</style>

